import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  private scripts: { [key: string]: { loaded: boolean; src: string } } = {};

  constructor() { }

  load(scriptName: string, scriptUrl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Check if the script is already loaded
      if (this.scripts[scriptName]?.loaded) {
        resolve();
        return;
      }

      // Create a script element
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.type = 'text/javascript';
      scriptElement.async = true;

      // Set up event listeners
      scriptElement.onload = () => {
        this.scripts[scriptName] = { loaded: true, src: scriptUrl };
        resolve();
      };

      scriptElement.onerror = () => {
        reject(new Error(`Failed to load script: ${scriptUrl}`));
      };

      // Append the script to the document body
      document.body.appendChild(scriptElement);
    });
  }

  loadMultiple(scripts: { name: string; url: string }[]): Promise<void[]> {
    const loadPromises = scripts.map((script) =>
      this.load(script.name, script.url)
    );
    return Promise.all(loadPromises);
  }

}
